import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.is-array";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import "core-js/modules/web.timers";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import React, { useState, useCallback, useEffect, useContext } from 'react';
import Block from 'wfui-digital-core/es/Block';
import PageContext from 'wfui-digital-core/es/PageContext';
import WFMastheadContext from 'wfui-digital-core/es/WFMastheadContext';
import useDevice from 'wfui-digital-core/es/useDevice';
import useOutsideEvents from 'wfui-digital-core/es/useOutsideEvents';
import useKeyEvent from 'wfui-digital-core/es/useKeyEvent';
import useWindowBounds from 'wfui-digital-core/es/useWindowBounds';
import { getClasses } from 'wfui-digital-core/es/lib';
import Overlay from './support/overlay/Overlay';
import Header from './support/header/Header';
import Links from './support/links/Links';
import styles from './WFMastheadNavigationMenu.less';

var MenuContent = function MenuContent() {
  var _useContext = useContext(WFMastheadContext),
      setMenuOpen = _useContext.setMenuOpen;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      container = _useState2[0],
      setContainer = _useState2[1]; // This method of obtaining a ref is used because the effect we are passing
  // it to (useOutsideEvents) won't see the ref value on the first render.


  var containerRef = useCallback(function (node) {
    if (node !== null) {
      setContainer(node);
    }
  }, []);
  useOutsideEvents({
    container: container,
    onOutsideEvent: function onOutsideEvent() {
      return setMenuOpen(false);
    }
  });
  useKeyEvent({
    keyMap: {
      'Escape': function Escape() {
        return setMenuOpen(false);
      }
    }
  });
  return /*#__PURE__*/React.createElement(Block, {
    layout: true,
    vertical: true,
    flex: true,
    elementRef: containerRef
  }, /*#__PURE__*/React.createElement(Header, null), /*#__PURE__*/React.createElement(Links, null));
};

var WFMastheadNavigationMenu = function WFMastheadNavigationMenu() {
  var _useContext2 = useContext(WFMastheadContext),
      menuOpen = _useContext2.menuOpen,
      setMenuOpen = _useContext2.setMenuOpen,
      menuType = _useContext2.menuType,
      subLogo = _useContext2.subLogo,
      showKeyLine = _useContext2.showKeyLine;

  var _useWindowBounds = useWindowBounds(),
      screenWidth = _useWindowBounds.width;

  var _useDevice = useDevice(),
      platform = _useDevice.platform;

  var _useContext3 = useContext(PageContext),
      getContainerRef = _useContext3.getContainerRef;

  var masthead = getContainerRef('masthead');

  var _useState3 = useState(menuOpen),
      _useState4 = _slicedToArray(_useState3, 2),
      open = _useState4[0],
      setOpen = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      closing = _useState6[0],
      setClosing = _useState6[1];

  var _useState7 = useState(0),
      _useState8 = _slicedToArray(_useState7, 2),
      top = _useState8[0],
      setTop = _useState8[1];

  useEffect(function () {
    if (menuOpen) {
      setOpen(true);
    } else if (open) {
      setClosing(true);
      setTimeout(function () {
        setOpen(false);
        setClosing(false);
      }, 498);
    }
  }, [menuOpen, open]);
  useEffect(function () {
    setMenuOpen(false);
  }, [platform, menuType, setMenuOpen]);
  useEffect(function () {
    var mastheadHeight = masthead ? masthead.offsetHeight : 0;
    var subLogoHeight = subLogo ? subLogo.offsetHeight : 0;
    setTop(mastheadHeight - subLogoHeight - (showKeyLine ? 4 : 0));
  }, [masthead, showKeyLine, subLogo, screenWidth]);
  var classes = ['menu', open && 'open', closing && 'closing'];
  var classNames = getClasses({
    styles: styles,
    classes: classes
  });
  return open ? /*#__PURE__*/React.createElement(Overlay, null, /*#__PURE__*/React.createElement(Block, {
    "data-testid": "WFMastheadNavigationMenu",
    layout: true,
    vertical: true,
    className: classNames,
    style: {
      top: top
    }
  }, /*#__PURE__*/React.createElement(MenuContent, null))) : null;
};

export default WFMastheadNavigationMenu;